/*global google*/
import isProduction from '../IsProduction';

const client = new google.payments.api.PaymentsClient({environment: isProduction ? 'PRODUCTION' : 'TEST'});
export default function() { return client; }